/**
 * Torso outfit textures: alien-cosmic-1
 */
export function drawTorso_mycelium_male(ctx, size, _options = {}) {
  // 9. ÁO SỢI NẤM ĐỐM BÀO TỬ PHÁT QUANG XANH LÁ NGỌC (FUNGALIA - MALE)
  ctx.fillStyle = '#14532d';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo hình vòm mũ nấm sinh học
  ctx.fillStyle = '#166534';
  ctx.beginPath();
  ctx.arc(size * 0.5, 0, size * 0.35, 0, Math.PI);
  ctx.fill();
  ctx.strokeStyle = '#4ade80';
  ctx.lineWidth = size * 0.02;
  ctx.stroke();

  // Mạng lưới sợi nấm hyphae
  ctx.strokeStyle = '#a7f3d0';
  ctx.lineWidth = size * 0.014;
  const drawHypha = (pts) => {
    ctx.beginPath();
    pts.forEach((pt, i) => (i === 0 ? ctx.moveTo(size * pt[0], size * pt[1]) : ctx.lineTo(size * pt[0], size * pt[1])));
    ctx.stroke();
  };
  drawHypha([
    [0.5, 0.25],
    [0.42, 0.4],
    [0.3, 0.5],
    [0.22, 0.7],
    [0.15, 0.85]
  ]);
  drawHypha([
    [0.42, 0.4],
    [0.52, 0.55],
    [0.48, 0.75],
    [0.58, 0.9]
  ]);
  drawHypha([
    [0.5, 0.25],
    [0.6, 0.38],
    [0.72, 0.48],
    [0.8, 0.68],
    [0.88, 0.88]
  ]);
  drawHypha([
    [0.72, 0.48],
    [0.65, 0.65],
    [0.7, 0.82]
  ]);

  // Các cụm đốm bào tử phát quang xanh lá ngọc
  const spores = [
    [0.42, 0.4, 0.045],
    [0.52, 0.55, 0.038],
    [0.3, 0.5, 0.035],
    [0.72, 0.48, 0.042],
    [0.65, 0.65, 0.032],
    [0.22, 0.7, 0.036],
    [0.48, 0.75, 0.04],
    [0.8, 0.68, 0.034],
    [0.5, 0.3, 0.05]
  ];
  spores.forEach((sp) => {
    ctx.fillStyle = 'rgba(16, 185, 129, 0.45)';
    ctx.beginPath();
    ctx.arc(size * sp[0], size * sp[1], size * sp[2] * 1.8, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#34d399';
    ctx.beginPath();
    ctx.arc(size * sp[0], size * sp[1], size * sp[2], 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#f0fdf4';
    ctx.beginPath();
    ctx.arc(size * sp[0], size * sp[1], size * sp[2] * 0.4, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawTorso_mycelium_female(ctx, size, _options = {}) {
  // 10. VÁY TƠ NẤM DẠ QUANG XỐP MỀM (FUNGALIA - FEMALE)
  const funGrad = ctx.createLinearGradient(0, 0, 0, size);
  funGrad.addColorStop(0, '#065f46');
  funGrad.addColorStop(0.5, '#047857');
  funGrad.addColorStop(1, '#4c1d95');
  ctx.fillStyle = funGrad;
  ctx.fillRect(0, 0, size, size);

  // Màng tơ nấm rủ nhẹ dạng ren sinh học
  ctx.fillStyle = 'rgba(167, 243, 208, 0.35)';
  ctx.beginPath();
  ctx.moveTo(size * 0.2, 0);
  ctx.quadraticCurveTo(size * 0.5, size * 0.28, size * 0.8, 0);
  ctx.lineTo(size * 0.85, size * 0.45);
  ctx.quadraticCurveTo(size * 0.5, size * 0.6, size * 0.15, size * 0.45);
  ctx.closePath();
  ctx.fill();
  ctx.strokeStyle = '#6ee7b7';
  ctx.lineWidth = size * 0.015;
  ctx.stroke();

  ctx.strokeStyle = 'rgba(255, 255, 255, 0.3)';
  ctx.lineWidth = size * 0.008;
  for (let x = size * 0.25; x <= size * 0.75; x += size * 0.1) {
    ctx.beginPath();
    ctx.moveTo(x, size * 0.15);
    ctx.lineTo(x, size * 0.5);
    ctx.stroke();
  }

  ctx.fillStyle = '#10b981';
  ctx.fillRect(0, size * 0.62, size, size * 0.06);

  const fSpores = [
    [0.25, 0.72],
    [0.35, 0.85],
    [0.48, 0.78],
    [0.6, 0.88],
    [0.72, 0.75],
    [0.38, 0.32],
    [0.62, 0.32],
    [0.5, 0.22],
    [0.82, 0.65],
    [0.18, 0.68]
  ];
  fSpores.forEach((pt) => {
    ctx.fillStyle = 'rgba(52, 211, 153, 0.5)';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], size * 0.035, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#a7f3d0';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], size * 0.018, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawTorso_synapse_male(ctx, size, _options = {}) {
  // 11. ÁO XUNG ĐIỆN THẦN KINH NỐI CÁC HẠCH SYNAPSE TÍM NEON (SYNAPSE-NET - MALE)
  ctx.fillStyle = '#09090b';
  ctx.fillRect(0, 0, size, size);

  ctx.strokeStyle = '#7c3aed';
  ctx.lineWidth = size * 0.03;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, 0);
  ctx.lineTo(size * 0.5, size);
  ctx.stroke();

  ctx.strokeStyle = '#c084fc';
  ctx.lineWidth = size * 0.016;
  const synBranches = [
    [
      [0.5, 0.18],
      [0.32, 0.15],
      [0.2, 0.28]
    ],
    [
      [0.5, 0.18],
      [0.68, 0.15],
      [0.8, 0.28]
    ],
    [
      [0.5, 0.42],
      [0.3, 0.45],
      [0.18, 0.6]
    ],
    [
      [0.5, 0.42],
      [0.7, 0.45],
      [0.82, 0.6]
    ],
    [
      [0.5, 0.7],
      [0.35, 0.75],
      [0.25, 0.9]
    ],
    [
      [0.5, 0.7],
      [0.65, 0.75],
      [0.75, 0.9]
    ]
  ];
  synBranches.forEach((b) => {
    ctx.beginPath();
    b.forEach((pt, i) => (i === 0 ? ctx.moveTo(size * pt[0], size * pt[1]) : ctx.lineTo(size * pt[0], size * pt[1])));
    ctx.stroke();
  });

  const nodes = [
    [0.5, 0.18, 0.055],
    [0.5, 0.42, 0.065],
    [0.5, 0.7, 0.055],
    [0.2, 0.28, 0.045],
    [0.8, 0.28, 0.045],
    [0.18, 0.6, 0.042],
    [0.82, 0.6, 0.042],
    [0.25, 0.9, 0.038],
    [0.75, 0.9, 0.038]
  ];
  nodes.forEach((n) => {
    ctx.fillStyle = 'rgba(168, 85, 247, 0.5)';
    ctx.beginPath();
    ctx.arc(size * n[0], size * n[1], size * n[2] * 1.7, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#a855f7';
    ctx.beginPath();
    ctx.arc(size * n[0], size * n[1], size * n[2], 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#faf5ff';
    ctx.beginPath();
    ctx.arc(size * n[0], size * n[1], size * n[2] * 0.45, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawTorso_synapse_female(ctx, size, _options = {}) {
  // 12. ÁO SÓNG NÃO QUANG PHỔ (SYNAPSE-NET - FEMALE)
  const synFGrad = ctx.createLinearGradient(0, 0, 0, size);
  synFGrad.addColorStop(0, '#2e1065');
  synFGrad.addColorStop(0.5, '#3b0764');
  synFGrad.addColorStop(1, '#09090b');
  ctx.fillStyle = synFGrad;
  ctx.fillRect(0, 0, size, size);

  const rX = size * 0.5,
    rY = size * 0.35;
  [0.08, 0.16, 0.24, 0.32].forEach((radFrac, idx) => {
    ctx.strokeStyle = `rgba(192, 132, 252, ${0.7 - idx * 0.15})`;
    ctx.lineWidth = size * 0.012;
    ctx.beginPath();
    ctx.arc(rX, rY, size * radFrac, 0, Math.PI * 2);
    ctx.stroke();
  });

  const waveColors = ['#c084fc', '#38bdf8', '#f472b6', '#fde047', '#4ade80'];
  waveColors.forEach((wc, widx) => {
    const yBase = size * (0.5 + widx * 0.09);
    const freq = 3 + widx * 0.8;
    const amp = size * (0.035 - widx * 0.003);
    ctx.strokeStyle = wc;
    ctx.lineWidth = size * 0.014;
    ctx.beginPath();
    for (let x = 0; x <= size; x += 4) {
      const y = yBase + Math.sin((x / size) * Math.PI * freq + widx) * amp;
      if (x === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    ctx.stroke();
  });

  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(rX, rY, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_aurora_male(ctx, size, _options = {}) {
  // 13. ÁO CHOÀNG DẢI SÓNG GRADIENT CỰC QUANG XANH LỤC - TÍM (BOREALIS-V - MALE)
  ctx.fillStyle = '#022c22';
  ctx.fillRect(0, 0, size, size);

  ctx.fillStyle = '#f1f5f9';
  ctx.fillRect(size * 0.2, 0, size * 0.6, size * 0.14);
  ctx.strokeStyle = '#cbd5e1';
  ctx.lineWidth = size * 0.015;
  ctx.strokeRect(size * 0.2, 0, size * 0.6, size * 0.14);

  const aurGrad = ctx.createLinearGradient(0, size * 0.15, size, size);
  aurGrad.addColorStop(0, '#10b981');
  aurGrad.addColorStop(0.45, '#06b6d4');
  aurGrad.addColorStop(0.8, '#8b5cf6');
  aurGrad.addColorStop(1, '#ec4899');

  ctx.fillStyle = aurGrad;
  ctx.beginPath();
  ctx.moveTo(0, size * 0.2);
  ctx.bezierCurveTo(size * 0.35, size * 0.35, size * 0.65, size * 0.15, size, size * 0.35);
  ctx.lineTo(size, size * 0.7);
  ctx.bezierCurveTo(size * 0.65, size * 0.5, size * 0.35, size * 0.7, 0, size * 0.55);
  ctx.closePath();
  ctx.fill();

  ctx.fillStyle = 'rgba(52, 211, 153, 0.45)';
  ctx.beginPath();
  ctx.moveTo(0, size * 0.65);
  ctx.bezierCurveTo(size * 0.4, size * 0.8, size * 0.7, size * 0.65, size, size * 0.85);
  ctx.lineTo(size, size);
  ctx.lineTo(0, size);
  ctx.closePath();
  ctx.fill();

  ctx.fillStyle = '#ffffff';
  [
    [0.12, 0.18],
    [0.85, 0.2],
    [0.15, 0.62],
    [0.9, 0.6],
    [0.45, 0.48],
    [0.55, 0.82]
  ].forEach((st) => {
    ctx.beginPath();
    ctx.arc(size * st[0], size * st[1], size * 0.015, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawTorso_aurora_female(ctx, size, options = {}) {
  // 14. VÁY LỤA CỰC QUANG DẠ QUANG (BOREALIS-V - FEMALE)
  const aurFGrad = ctx.createLinearGradient(0, 0, size, size);
  aurFGrad.addColorStop(0, '#1e1b4b');
  aurFGrad.addColorStop(0.5, '#312e81');
  aurFGrad.addColorStop(1, '#0f172a');
  ctx.fillStyle = aurFGrad;
  ctx.fillRect(0, 0, size, size);

  ctx.fillStyle = options.skinColor || '#fcd5b5';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.3, size * 0.14, 0, 0, Math.PI);
  ctx.fill();
  ctx.strokeStyle = '#22d3ee';
  ctx.lineWidth = size * 0.018;
  ctx.stroke();

  const silkAurGrad = ctx.createLinearGradient(0, 0, 0, size);
  silkAurGrad.addColorStop(0, '#22d3ee');
  silkAurGrad.addColorStop(0.35, '#34d399');
  silkAurGrad.addColorStop(0.7, '#a855f7');
  silkAurGrad.addColorStop(1, '#f472b6');

  ctx.fillStyle = silkAurGrad;
  ctx.beginPath();
  ctx.moveTo(size * 0.15, size * 0.22);
  ctx.bezierCurveTo(size * 0.45, size * 0.38, size * 0.65, size * 0.25, size * 0.85, size * 0.4);
  ctx.bezierCurveTo(size * 0.7, size * 0.65, size * 0.4, size * 0.55, size * 0.15, size * 0.72);
  ctx.bezierCurveTo(size * 0.35, size * 0.88, size * 0.65, size * 0.78, size * 0.85, size * 0.95);
  ctx.lineTo(size * 0.8, size);
  ctx.lineTo(size * 0.1, size);
  ctx.closePath();
  ctx.fill();

  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = size * 0.012;
  ctx.stroke();

  ctx.fillStyle = '#fef08a';
  [
    [0.28, 0.45],
    [0.75, 0.35],
    [0.5, 0.6],
    [0.32, 0.8],
    [0.68, 0.85]
  ].forEach((st) => {
    ctx.beginPath();
    ctx.arc(size * st[0], size * st[1], size * 0.016, 0, Math.PI * 2);
    ctx.fill();
  });
}

export const alien_cosmic_1_drawers = {
  mycelium_male: drawTorso_mycelium_male,
  mycelium_female: drawTorso_mycelium_female,
  synapse_male: drawTorso_synapse_male,
  synapse_female: drawTorso_synapse_female,
  aurora_male: drawTorso_aurora_male,
  aurora_female: drawTorso_aurora_female
};
